export const REJECTED = 'REJECTED';
export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';